<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true"
  [config]="{ignoreBackdropClick: true, keyboard: false}" (onShown)="onShown()">
  <div class="modal-dialog modal-lg">
    <mat-progress-bar *ngIf="isBusy" mode="indeterminate"></mat-progress-bar>
    <div class="card modal-content" *ngIf="form">
      <form (ngSubmit)="save()" [formGroup]="form">
        <div class="header">
          <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h2>Questionário de Anamnese</h2>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger" *ngIf="errors.length > 0">
            <h3>Oops! Algo deu errado:</h3>
            <ul>
              <li *ngFor="let error of errors">{{error}}</li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>TipoResposta</mat-label>
                <input matInput formControlName="tipoResposta" type="text" />
                <mat-error>Informe um TipoResposta válido.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>GrupoAnamneseId</mat-label>
                <input matInput formControlName="grupoAnamneseId" type="text" />
                <mat-error>Informe um GrupoAnamneseId válido.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>GrupoAnamnese</mat-label>
                <input matInput formControlName="grupoAnamnese" type="text" />
                <mat-error>Informe um GrupoAnamnese válido.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>Respostas</mat-label>
                <input matInput formControlName="respostas" type="text" />
                <mat-error>Informe um Respostas válido.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>DescricaoPergunta</mat-label>
                <input matInput formControlName="descricaoPergunta" type="text" />
                <mat-error>Informe um DescricaoPergunta válido.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>RespostaPadrao</mat-label>
                <input matInput formControlName="respostaPadrao" type="text" />
                <mat-error>Informe um RespostaPadrao válido.</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
      <div class="footer">
        <mat-slide-toggle [(ngModel)]="multiCreate" color="primary" *ngIf="newItem" style="margin-right: 10px;">
          Continuar Incluindo
        </mat-slide-toggle>
        <button mat-flat-button [disabled]="!form.valid || isBusy" type="submit" (click)="save()" color="primary"
          class="button-row">
          <span> Salvar</span>
        </button>
        <button mat-stroked-button type="button" [routerLink]="" (click)="close()" class="button-row">
          <span> Cancelar</span>
        </button>
      </div>
    </div>
  </div>
</div>